import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class ActivitiesService {
  constructor(private apiService: ApiService) {}

  getFeed(): Promise<any[]> {
    return this.apiService.request<any[]>('/activities', 'GET');
  }

  react(activityId: string, emoji: string): Promise<any> {
    return this.apiService.request(`/activities/${activityId}/react`, 'POST', {
      emoji,
    });
  }

  archive(activityId: string): Promise<{ success: boolean }> {
    return this.apiService.request(
      `/activities/${activityId}/archive`,
      'POST',
    );
  }

  comment(activityId: string, message: string): Promise<any> {
    return this.apiService.request(
      `/activities/${activityId}/comments`,
      'POST',
      { message },
    );
  }
}
